import {
  IValueAddedService,
  IValueAddedServiceUpdatePayload,
} from "../../../types/master/valueAddedServiceInterface";
import {
  ValueAddedServiceActionTypes,
  ValueAddedServiceActions,
} from "../../actionTypes/master/valueAddedServiceActionTypes";

export const getValueAddedServiceList = (search?: string): ValueAddedServiceActionTypes => ({
  type: ValueAddedServiceActions.GET_VALUE_ADDED_SERVICE_LIST,
  payload: search,
});

export const setValueAddedServiceList = (payload: Array<IValueAddedService>): ValueAddedServiceActionTypes => ({
  type: ValueAddedServiceActions.SET_VALUE_ADDED_SERVICE_LIST,
  payload,
});

export const editValueAddedServices = (payload: IValueAddedServiceUpdatePayload): ValueAddedServiceActionTypes => ({
  type: ValueAddedServiceActions.EDIT_VALUE_ADDED_SERVICES,
  payload,
});
